import { defineMessages } from "../i18n/core";

export const confirmEmailMessages = defineMessages({
  "pt-BR": {
    workingTitle: "Confirmando o novo e-mail",
    working: "Conferindo o link de confirmação…",
    doneTitle: "E-mail confirmado",
    done: (email: string) => `A troca foi concluída. A partir de agora, entre com ${email}. O endereço anterior recebeu um aviso sobre a troca.`,
    missingTitle: "Link incompleto",
    missing: "Abra o link de confirmação exatamente como ele chegou no seu e-mail.",
    invalidTitle: "Link de confirmação indisponível",
    invalidHint: "O e-mail da sua conta não mudou. Se ainda quiser trocar, peça de novo em Configurações, na seção Sua conta. Cada link vale por 1 hora e uma única vez.",
    takenTitle: "Este e-mail já está em uso",
    takenHint: "O e-mail da sua conta não mudou. Em Configurações, na seção Sua conta, peça a troca para outro endereço.",
    transientTitle: "Não foi possível confirmar agora",
    failed: "Não foi possível confirmar. Tente de novo.",
    retry: "Tentar de novo",
    goToConsole: "Ir para a console",
    goToLogin: "Entrar",
  },
  "en-US": {
    workingTitle: "Confirming your new email",
    working: "Checking the confirmation link…",
    doneTitle: "Email confirmed",
    done: (email: string) => `The change is complete. From now on, sign in with ${email}. The previous address received a notice about the change.`,
    missingTitle: "Incomplete link",
    missing: "Open the confirmation link exactly as it arrived in your email.",
    invalidTitle: "Confirmation link unavailable",
    invalidHint: "Your account email did not change. If you still want to change it, request it again in Settings, under Your account. Each link is valid for 1 hour and only once.",
    takenTitle: "This email is already in use",
    takenHint: "Your account email did not change. In Settings, under Your account, request the change to a different address.",
    transientTitle: "Could not confirm right now",
    failed: "Could not confirm. Try again.",
    retry: "Try again",
    goToConsole: "Go to the console",
    goToLogin: "Sign in",
  },
  es: {
    workingTitle: "Confirmando tu nuevo correo",
    working: "Revisando el enlace de confirmación…",
    doneTitle: "Correo confirmado",
    done: (email: string) => `El cambio se completó. A partir de ahora, inicia sesión con ${email}. La dirección anterior recibió un aviso sobre el cambio.`,
    missingTitle: "Enlace incompleto",
    missing: "Abre el enlace de confirmación tal como llegó a tu correo.",
    invalidTitle: "Enlace de confirmación no disponible",
    invalidHint: "El correo de tu cuenta no cambió. Si todavía quieres cambiarlo, pídelo de nuevo en Configuración, en la sección Tu cuenta. Cada enlace vale por 1 hora y una sola vez.",
    takenTitle: "Este correo ya está en uso",
    takenHint: "El correo de tu cuenta no cambió. En Configuración, en la sección Tu cuenta, pide el cambio a otra dirección.",
    transientTitle: "No se pudo confirmar ahora",
    failed: "No se pudo confirmar. Inténtalo de nuevo.",
    retry: "Intentar de nuevo",
    goToConsole: "Ir a la consola",
    goToLogin: "Iniciar sesión",
  },
});
